import { render, staticRenderFns } from "./MenuTabsTodasHomologacao.vue?vue&type=template&id=7ab56b1d"
import script from "./MenuTabsTodasHomologacao.vue?vue&type=script&lang=js"
export * from "./MenuTabsTodasHomologacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports